import { render, staticRenderFns } from "./CrossCellMobile.vue?vue&type=template&id=2d6402fe&scoped=true"
import script from "./CrossCellMobile.vue?vue&type=script&lang=js"
export * from "./CrossCellMobile.vue?vue&type=script&lang=js"
import style0 from "./CrossCellMobile.vue?vue&type=style&index=0&id=2d6402fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6402fe",
  null
  
)

export default component.exports